export const tr = {
    'accepted-status': 'Gösterimlere izin verildi',
    'active-status': 'Aktif',
    'archived-status': 'Arşivde',
    'banner-type-content-promotion': 'İçerik promosyonu',
    'banner-type-cpm-indoor': 'Dahili reklam',
    'banner-type-cpm-indoor-1': 'İç mekan reklamları',
    'banner-type-cpm-outdoor': 'Dış mekan reklamı',
    'banner-type-cpm_audio': 'Ses',
    'banner-type-cpm_banner': "Medya banner'ı",
    'banner-type-cpm_geoproduct': "Yandex.Metro banner'ı",
    'banner-type-cpm_geoproduct-new': 'Konum bazlı alanlarda banner',
    'banner-type-cpm_price': 'todo',
    'banner-type-cpm_video': 'Video',
    'banner-type-cpm_yndx_frontpage': "Ana sayfa medya banner'ı",
    'banner-type-dynamic': 'Dinamik reklam',
    'banner-type-internal': 'Dahili reklam',
    'banner-type-internal-autobudget': 'Otomatik bütçeli kampanya',
    'banner-type-internal-distrib': 'Dağıtım reklamları',
    'banner-type-internal-free': 'Ücretsiz reklamlar',
    'banner-type-mcbanner': "Arama banner'ı",
    'banner-type-performance': 'Akıllı banner',
    'banner-type-text-mobile': 'Mobil metin-grafik reklam',
    'button-group-type-chooser-banners': "Banner'lar",
    'custom-targeting': 'todo',
    'date-campaigns': 'todo',
    displays: 'todo',
    'draft-status': 'Taslak',
    'edit-group-hint-campaigns-part': {
        one: 'toplam {countCampaigns} kampanyadan',
        some: 'toplam {countCampaigns} kampanyadan',
        many: 'toplam {countCampaigns} kampanyadan',
        none: 'toplam {countCampaigns} kampanyadan'
    },
    'edit-group-hint-groups-part': {
        one: '{count} grup seçildi',
        some: '{count} grup seçildi',
        many: '{count} grup seçildi',
        none: '{count} grup seçildi'
    },
    'edit-group-hint-only-campaigns-part': {
        one: '{count} kampanya seçildi',
        some: '{count} kampanya seçildi',
        many: '{count} kampanya seçildi',
        none: '{count} kampanya seçildi'
    },
    'fixed-targeting': 'todo',
    'group-type-chooser-audio': 'ses',
    'group-type-chooser-banners': "banner'lar",
    'group-type-chooser-geoproduct': "Yandex.Metro'da banner",
    'group-type-chooser-geoservice': 'konum bazlı alanlarda banner',
    'group-type-chooser-indoor': 'dahili reklam',
    'group-type-chooser-indoor-1': 'iç mekan reklamları',
    'group-type-chooser-outdoor': 'dış mekan reklamı',
    'group-type-chooser-video': 'video',
    'group-type-text': 'Metin-grafik reklam',
    ltv: 'todo',
    'moderation-status': 'Moderasyonda',
    'no-status': 'Reklamlar oluşturulmadı',
    'preaccepted-status': 'Gösterimlere ön izin verildi',
    'previous-version-showing-status-desc': 'Önceki sürüm gösterilmektedir',
    'processing-status': 'İşleniyor',
    'rejected-status': 'Reddedildi',
    'showing-status': 'Gösterimler devam ediyor',
    'showing-status-desc': 'Gösterimler devam ediyor',
    'stopped-status': 'Durduruldu',
    'title-package': 'todo'
};
